<template>
  <div>
    <loader v-show="$wait.is('getRadovi')"></loader>
    <v-container v-show="!$wait.is('getRadovi')">

      <akademsko-osoblje></akademsko-osoblje>
    </v-container>
  </div>
</template>


<script>
import "../assets/compiled-icons/graduated";
import "../assets/compiled-icons/teacher";
import "../assets/compiled-icons/audience";

import { mapGetters } from "vuex";
import AkademskoOsoblje from "./Radovi";

export default {
  name: "Home",
  computed: {
    ...mapGetters(["hasAdminRights", "getDeviceType"]),
  },
  components: {
    AkademskoOsoblje,
  },
};
</script>